import { createRootRoute, Outlet, ScrollRestoration } from "@tanstack/react-router";
import { useEffect } from "react";

import LdSetup from "../features/auth/LdSetup";
import { useGetApiUrl } from "../helpers/helpers";
import useAppStore from "../store/appStateZustand";

function RootComponent() {
  const saApiUrl = useGetApiUrl();

  useEffect(() => {
    const cloneEnvironment = useAppStore.getState().cloneEnvironment;
    if (cloneEnvironment === null || cloneEnvironment === "default") {
      useAppStore.setState({ apiUrl: saApiUrl });
    }
  }, [saApiUrl]);

  return (
    <>
      <ScrollRestoration />
      <LdSetup />
      <Outlet />
    </>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
